/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { Text } from '@/shared/ui';

/**
 * Small red dot marking an unseen inbound Social update. Renders nothing
 * when `show` is false, so callers can use it unconditionally.
 *
 * Default (`inline` false): absolutely positioned corner badge -- expects an
 * ancestor with `position: relative` (or `fixed`/`absolute`) to anchor to.
 * `inline` true: a plain flow dot sized for sitting next to text/icons, e.g.
 * an inbox tab label.
 */
export function SocialUnseenDot({ show, inline = false }: { show: boolean; inline?: boolean }) {
  if (!show) return null;
  if (inline) {
    return (
      <Text
        component="span"
        data-testid="social-unseen-dot"
        aria-hidden="true"
        className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--status-error)] shrink-0"
      />
    );
  }
  return (
    <Text
      component="span"
      data-testid="social-unseen-dot"
      aria-hidden="true"
      className="absolute top-0 right-0 w-3 h-3 rounded-full bg-[var(--status-error)] border-2 border-[var(--surface-primary)]"
    />
  );
}
